import axios from '../../util/Api';
import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Table from '../../components/Table/Basic';
import { ParamsContext } from '../Context/ParamsContext';
import { Switch } from 'antd';
import Edit from './Edit';

const List = () => {
  const [loading, setLoading] = useState(true);
  const [sicknesses, setSicknesses] = useState([]);
  const [total, setTotal] = useState(null);
  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchSicknessList();
  }, [params]);

  const fetchSicknessList = () => {
    setLoading(true);
    const url = `/sickness`;
    axios.get(url, { params: params }).then(resp => {
      setSicknesses(resp.data.sickness);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const columns = [
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      filter: true,
      sorter: true,
    },
    {
      title: 'Status',
      key: 'status',
      sorter: true,
      render: record => {
        return record.status.label;
      }
    },
    {
      title: '',
      render: record => {
        return <Edit sickness={record} />;
      }
    }
  ];
  return (
    <Auxiliary>
      <Table
        columns={columns}
        dataSource={sicknesses}
        loading={loading}
        total={total}
      />
    </Auxiliary>
  );
}

export default List;